import { Box, Grid } from "@mui/material";
import { ReactElement } from "react";
import { useAppSelector } from "../../app/hooks";
import OverlaySpinner from "../../common/components/functional/overlaySpinner/OverlaySpinner";

type Props = {
  top: ReactElement;
  left: ReactElement;
  right: ReactElement[];
};

const DashboardGridLayout = ({ top, left, right }: Props) => {
  // TODO: add one main status of dashboard slice
  const { status: hrTasklistStatus } = useAppSelector(
    (state) => state.dashboard.hrTasklist,
  );
  const { status: talentsStatus } = useAppSelector(
    (state) => state.dashboard.talents,
  );

  const isLoading =
    hrTasklistStatus === "pending" || talentsStatus === "pending";

  return (
    <>
      <OverlaySpinner isLoading={isLoading} />
      {top}
      <Box
        sx={{ maxWidth: "1800px", flex: 1, height: "100%", minHeight: 0 }}
      >
        <Grid
          container
          spacing={2}
          sx={{ height: "100%", flexWrap: "nowrap" }}
        >
          {left}
          <Grid item container xs={8.9} sx={{ height: "100%", minHeight: 0 }}>
            <Grid
              item
              xs
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minWidth: 0,
                minHeight: 0,
              }}
            >
              {right}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default DashboardGridLayout;
